import { ExclamationTriangleIcon, TrashIcon } from '@heroicons/react/24/outline'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from '@/components/Button'
import messages from '@/components/Form/AudienceTargeting/messages'
import Modal from '@/components/Modal'

/**
 * Delete audience button and confirmation prompt
 *
 * @param {Function} onClick - Function to call when the confirmation button is clicked
 */
const DeleteAudience = ({ onClick }: any) => {
  const [isPromptOpen, setIsPromptOpen] = useState(false)

  return (
    <>
      <Modal size="xs" isOpen={isPromptOpen} onClose={() => setIsPromptOpen(false)}>
        <div className="p-4">
          <div className="flex items-center space-x-4">
            <div className="mx-auto flex h-12 w-16 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
              <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
            </div>
            <div className="text-sm">
              <FormattedMessage {...messages.confirmDeleteAudience} />
            </div>
          </div>
          <div className="mt-12 flex items-center justify-end gap-x-6">
            <Button
              color="transparent"
              onClick={() => {
                setIsPromptOpen(false)
              }}
            >
              <FormattedMessage id="Cancel" defaultMessage="Cancel" />
            </Button>
            <Button
              color="warning"
              onClick={() => {
                setIsPromptOpen(false)
                onClick()
              }}
            >
              <FormattedMessage id="Delete" defaultMessage="Delete" />
            </Button>
          </div>
        </div>
      </Modal>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div className="audience-delete" onClick={() => setIsPromptOpen(true)}>
        <TrashIcon className="relative inline-flex h-4 w-4 flex-col items-start justify-start text-zinc-400" />
      </div>
    </>
  )
}

DeleteAudience.displayName = 'DeleteAudience'

DeleteAudience.propTypes = {
  onClick: PropTypes.func
}

DeleteAudience.defaultProps = {
  onClick: () => {}
}

export default DeleteAudience
